<template>
<div>
    <form-errors :errors="formErrors" v-if="!hideFormErrors" />

    <div class="form-row">
        <div class="col">
            <div class="form-group-helpinfo">
                <div class="form-helpinfo-field">
                    <form-input label="ACA Employment Category" v-model="formData.aca_category" :errors="errors.aca_category" type="select" :options="acaCategoryOptions" />

                    <div class="field-helper-text" v-if="formData.aca_category == 'Full Time'">
                        On average at least 30 hours of service per week.
                    </div>

                    <div class="field-helper-text" v-if="formData.aca_category == 'Variable'">
                        On average less than 30 hours of service per week.
                    </div>

                </div>

                <more-info>If the new employee is expected to work at least 30 hours per week, on average, select "Full Time" for this field. If they are not expected to work at least 30 hours per week, select "Variable".</more-info>
            </div>
        </div>
    </div>

    <div class="form-row">
        <div class="col-8 col-sm-6">
            <form-input label="Start Date" v-model="formData.date_hired" :errors="errors.date_hired" type="date" />
        </div>
    </div>

    <div v-if="selectedCompany">
        <h5 class="mt-4 mb-2">{{ client.position_label_pretty }} Information</h5>

        <div v-for="(id, $index) in Object.keys(jobForms)" :key="id">
            <div class="row align-items-center">
                <div class="col">
                    <h6 class="mb-1">#{{ $index + 1 }}</h6>
                </div>
                <div class="col text-right">

                    <div class="dropdown d-inline-block" v-if="Object.keys(jobForms).length > 1">
                        <a href="" class="btn btn-icon dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-ellipsis-v"></i><span class="sr-only">More Actions</span>
                        </a>
                        <div class="dropdown-menu has-icons dropdown-menu-right">
                            <a class="dropdown-item" href @click.prevent="removeJob(id, $index)"><i class="fas fa-fw fa-times-circle mr-1"></i>Remove</a>
                        </div>
                    </div>

                </div>
            </div>

            <job-form
                :client="client"
                :company="selectedCompany"
                :instance="formData.jobs[$index]"
                ref="jobForms"
                @update="onJobUpdate($index, $event)"
                :all-jobs="formData.jobs"
                :show-pay-type-select="true"
            />
        </div>

        <p class="mb-2">
            <a href class="btn btn-link" @click.prevent="addJob()"><i class="far fa-plus mr-hf"></i>Add another</a>
        </p>
    </div>
</div>
</template>

<script>
import FormInput from '@/components/FormInput'
import FormErrors from '@/components/FormErrors'
import FormMixin from '@/mixins/Form'
import JobForm from '@/components/JobForm'
import moment from 'moment'

export default {
    mixins: [FormMixin],
    components: {FormInput, FormErrors, JobForm, },
    props: {client: {required: true}, employerHire: {required: false, default: null}, hideFormErrors: {required: false, default: false}},
    computed: {
        selectedCompany() {
            const companyId = this.employerHire?.company?.id
            return (this.client.companies || []).find(c => c.id == companyId) || null
        },
    },
    watch: {
        client: function() {
            this.reset()
        },
        employerHire: function() {
            this.reset()
        },
    },
    data() {
        const date_hired_latest = moment().add(364, 'days')

        const data = {
            suffixOptions: [
                {text: 'JR', value: 'JR'},
                {text: 'SR', value: 'SR'},
                {text: 'II', value: 'II'},
                {text: 'III', value: 'III'},
                {text: 'IV', value: 'IV'},
            ],
            acaCategoryOptions: [
                {text: 'Full Time', value: 'Full Time'},
                {text: 'Variable', value: 'Variable'},
            ],
            formLabels: {
                aca_category: 'ACA Category',
                date_hired: 'Start Date',
            },
            formRules: {
                date_hired: {presence: {allowEmpty: false}, date: {latest: date_hired_latest, tooLate: "can't be more than a year from today."}},
                aca_category: {presence: {allowEmpty: false},},
            },
            formData: this.makeFormData(),
            jobForms: {},
        }

        const eh = this.employerHire
        if (eh && eh.jobs && eh.jobs.length) {
            for (let i = 0; i < eh.jobs.length; i++) {
                data.jobForms[i] = i
            }
        }
        else {
            data.jobForms = {1: 1}
        }

        return data
    },
    methods: {
        makeFormData() {
            const eh = this.employerHire
            if (eh && eh.jobs && eh.jobs.length) {
                return {
                    date_hired: eh.date_hired || '',
                    aca_category: eh.aca_category || '',
                    jobs: eh.jobs.map(job => ({
                        id: job.id,
                        location: job.position?.work_location?.id ?? '',
                        position: job.position?.id ?? '',
                        pay_type: job.pay_type,
                        hourly_rate: job.hourly_rate,
                        salary_rate: job.salary_rate,
                        unit_rate: job.unit_rate,
                        default_hours: job.default_hours,
                    })),
                }
            }
            return {
                date_hired: eh?.date_hired || '',
                aca_category: eh?.aca_category || '',
                jobs: [],
            }
        },
        addJob() {
            const id = Math.max(1, ...Object.keys(this.jobForms)) + 1
            this.jobForms[id] = id
        },
        removeJob(id, idx) {
            const jobs = []
            this.formData.jobs = [];
            (this.$refs.jobForms || []).forEach((form, i) => {
                if (i != idx) {
                    jobs.push(form.getFormData())
                }
            })

            this.formData.jobs = jobs
            delete this.jobForms[id]
        },
        onJobUpdate(idx, data) {
            this.formData.jobs[idx] = data
        },
        onSubmit() {
            let errorCount = 0;
            (this.$refs.jobForms || []).forEach((form) => {
                if (!form.validate()) {
                    errorCount += 1
                }
            })

            // if (!this.validate() || errorCount) {
            //     return
            // }

            this.$emit('updated', this.getFormData())

        },
        reset: function() {
            (this.$refs.jobForms || []).forEach((form) => {
                form.reset()
            })
            this.jobForms = {1: 1}
            this.formErrors = []

            FormMixin.methods.reset.call(this)
        },
    }
}
</script>
